const videoParent = (e) => e.target.closest('[gdc-video-container]')
const currentVideo = (elem) => elem.querySelector('video')

function handleIcons(e) {
  const icons = e.target.querySelectorAll('.gdc-video-button-icon')

  icons.forEach((icon) => icon.classList.toggle('hide'))
}

function handleVideoPlay(e) {
  const video = currentVideo(videoParent(e))

  video.paused ? video.play() : video.pause()
  handleIcons(e)
}

function handleVideoAudio(e) {
  const video = currentVideo(videoParent(e))

  video.muted = !video.muted
  handleIcons(e)
}
